// extracted by mini-css-extract-plugin
module.exports = {"date-header":"DateHeader_date-header__313gK","key-performance-metrics":"DateHeader_key-performance-metrics__2aLFW"};